<script>
import BarChart from "@/shared/charts/bar-char/bar-chart.vue";
import { mapGetters } from "vuex";
import DashboardSpinner from "@/components/modules/new-dashboard/components/dashboard-spinner.vue";
import DashboardNoData from "@/components/modules/new-dashboard/components/dashboard-no-data.vue";

export default {
  name: "OrganizationsByEconomyActivity",
  components: {DashboardNoData, DashboardSpinner, BarChart },
  data: function () {
    return {
      colors: {
        optionList_selfAssessment_general_classification_activityAggregated_agriculture_short : "#19A39C",
        optionList_selfAssessment_general_classification_activityAggregated_manufacturing_short  : "#F32474",
        optionList_selfAssessment_general_classification_activityAggregated_construction_short : "#B7C51C",
        optionList_selfAssessment_general_classification_activityAggregated_minesEnergyWater_short  : "#22C2E5",
        optionList_selfAssessment_general_classification_activityAggregated_trade_short : "#FCA71C",
        optionList_selfAssessment_general_classification_activityAggregated_transport_short : "#CE51BF",
        optionList_selfAssessment_general_classification_activityAggregated_hospitalityFood_short: "#2AA816",
        optionList_selfAssessment_general_classification_activityAggregated_businessAdmin_short : "#8819A3",
        optionList_selfAssessment_general_classification_activityAggregated_publicAdmin_short : "#2F60A6",
        optionList_selfAssessment_general_classification_activityAggregated_socialCommunity_short:"#EAD325"
      },
      formattedSectors: [],
      groups: [],
      config: {
        width: 400,
        height: 260,
        marginTop: 50,
        marginBottom: 50,
      },
    };
  },
  computed: { ...mapGetters(["getOrganizationsByEconomicActivity"]) },
  watch: {
    getOrganizationsByEconomicActivity: {
      handler:   function() {
        this.formatSectors();
      },
      deep: true,
    }
  },
  mounted: function () {
    this.formatSectors();
  },
  methods: {
    hasData: function () {
      return !!this.formattedSectors.filter((s) => !!s.value).length;
    },

    formatSectors: function () {
      var total = this.getOrganizationsByEconomicActivity.data.reduce(
        (previousValue, currentValue) => previousValue + +currentValue.count,
        0
      );

      this.formattedSectors = this.getOrganizationsByEconomicActivity.data.filter(org=>!!org._id && !!org.count)
        .map((sector) => {
        return {
          value: +sector.count,
          label: this.$t(sector._id),
          color: this.colors[sector._id],
          tooltipText: sector._id,
          percentage: ((100 * +sector.count) / total).toFixed(0) + "%",
        };
      });
      this.groups =   this.formattedSectors.map(org=>org.label)
console.log(this.formattedSectors);
    },
  },
};
</script>

<template>
  <div>
    <dashboard-spinner :height="260" v-if="getOrganizationsByEconomicActivity.loading"></dashboard-spinner>

    <dashboard-no-data :height="260" v-if="!hasData() && !getOrganizationsByEconomicActivity.loading" ></dashboard-no-data>

    <div
      v-if="hasData() && !getOrganizationsByEconomicActivity.loading"
      class="public-institutions-by-sector"
      style="cursor: pointer;width:100%"

    >
      <bar-chart
        :chart-data="formattedSectors"
        :colors="colors"
        :config="config"
        :parent-height="false"
        :custom-group-sorting="groups"
      />
    </div>
  </div>
</template>

<style scoped>
.public-institutions-by-sector {
  grid-column-start: 3;
  grid-column-end: 4;
  grid-row-start: 2;
  grid-row-end: 3;
}
.loading {
  height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
